import { Component, RefObject } from "react"
import { Field, WrappedFieldProps } from "redux-form"
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import TextareaAutosize from "react-textarea-autosize"
import {
  Title,
  Wrapper,
  FieldWrapper,
  IconWrapper,
  Error,
} from "../style-components/style"

export interface IStyledFieldProps<P = {}> {
  name: string
  title: string
  icon: IconProp
  type: "text"
  placeholder: string
  component?: any
}

interface IProps extends IStyledFieldProps, WrappedFieldProps {}

interface IState {
  onFocus: boolean
}

export default class StyledTextareaField extends Component<IProps, IState> {
  private myRef: RefObject<HTMLDivElement>

  constructor(props: IProps) {
    super(props)
    this.state = {
      onFocus: false,
    }
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.myRef = React.createRef()
  }

  public componentDidMount(): void {
    const node =
      this.myRef.current && this.myRef.current.querySelector("textarea")
    if (node) {
      node.addEventListener("focus", this.onFocus)
      node.addEventListener("blur", this.onBlur)
    }
  }

  public componentWillUnmount(): void {
    const node =
      this.myRef.current && this.myRef.current.querySelector("textarea")
    if (node) {
      node.removeEventListener("focus", this.onFocus)
      node.removeEventListener("blur", this.onBlur)
    }
  }

  public render() {
    const {
      name,
      title,
      input,
      meta,
      icon,
      component,
      type,
      placeholder,
    } = this.props
    return (
      <Wrapper ref={this.myRef}>
        <Title active={this.state.onFocus} htmlFor={name}>
          {title}
        </Title>
        <FieldWrapper active={this.state.onFocus}>
          <IconWrapper active={this.state.onFocus}>
            <FontAwesomeIcon icon={icon} />
          </IconWrapper>
          <Field
            name={input.name}
            component={component || renderField}
            type={type}
            placeholder={placeholder}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
        </FieldWrapper>
        {meta.touched && meta.error && <Error>{meta.error}</Error>}
      </Wrapper>
    )
  }

  private onFocus() {
    this.setState({
      onFocus: true,
    })
  }

  private onBlur() {
    this.setState({
      onFocus: false,
    })
  }
}

const renderField = (props: WrappedFieldProps & { placeholder: string }) => (
  <TextareaAutosize {...props.input} placeholder={props.placeholder} />
)
